<template>
  <main class="flex justify-center font-zona">
    <div
      class="flex max-sm:flex-col gap-5 lg:gap-10 w-full min-[1200px]:w-4/5 max-[1199px]:p-5 py-5"
    >
      <!-- NEWS LIST -->
      <div v-if="news.length > 0 && !isLoading" class="w-full">
        <div
          class="grid grid-cols-1 min-[900px]:grid-cols-2 gap-10 w-full h-fit"
        >
          <router-link
            v-for="item in news"
            :key="item.id"
            :to="`/mm/detail/${item.id}`"
            v-motion-slide-visible-once-bottom
            :duration="1000"
            class="bg-gray-100 p-5 space-y-5 shadow cursor-pointer"
          >
            <h6 class="font-bold text-sm text-green">
              {{ item.created_at }}
            </h6>
            <img
              :src="item.image"
              :alt="item.id"
              class="w-full h-[12rem] object-cover"
            />
            <h1 class="font-bold text-xl line-clamp-1">
              {{ lang === "mn" ? item.title : item.title_en }}
            </h1>
            <p class="line-clamp-5 text-sm font-thin leading-6">
              {{ lang === "mn" ? item.summary : item.summary_en }}
            </p>
            <button
              class="bg-green py-2 w-[10rem] rounded-full text-white text-sm uppercase hover:scale-105"
            >
              {{ lang === "mn" ? "Дэлгэрэнгүй" : "Read more" }}
            </button>
          </router-link>
        </div>
      </div>
      <div
        v-else-if="news.length === 0 && !isLoading"
        class="flex justify-center items-center w-full h-[10rem] md:text-2xl bg-gray-100"
      >
        {{ lang === "mn" ? "Мэдээ хоосон байна" : "No News Found" }}
      </div>

      <div
        v-else-if="isLoading"
        class="flex justify-center items-center w-full h-[50vh]"
      >
        <SpinLoading />
      </div>

      <NewsPageSide />
    </div>
  </main>
</template>

<script setup>
import clientInstance from "@/lib/clientInstance";
import { computed } from "vue";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

const store = useStore();
const news = ref([]);
const isLoading = ref(false);
const lang = computed(() => store.getters.getLanguage);

onMounted(async () => {
  isLoading.value = true;
  try {
    const res = await clientInstance.get("/get/pdac-news");

    news.value = res.data.news;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
});
</script>
